export const MENU_DATA = {
  dashboard: {
    id: 'group-dashboard',
    title: 'dashboard',
    type: 'group',
    icon: 'dashboard',
    children: [
      {
        id: 'dashboard',
        title: 'dashboard',
        type: 'collapse',
        icon: 'dashboard',
        children: [
          {
            id: 'default',
            title: 'default',
            type: 'item',
            url: '/dashboard/default',
            breadcrumbs: false
          },
          {
            id: 'analytics',
            title: 'analytics',
            type: 'item',
            url: '/dashboard/analytics',
            breadcrumbs: false
          }
        ]
      },
      {
        id: 'components',
        title: 'components',
        type: 'item',
        url: '/components-overview/buttons',
        icon: 'components',
        target: true,
        chip: {
          label: 'new',
          color: 'primary',
          size: 'small',
          variant: 'combined'
        }
      }
    ]
  }
};